import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import reducer from 'store/rootReducer';

export const store = configureStore({
  reducer: reducer,

  /** Need to ignore the serializable check for the WASM
   * C++ Vector that isn't serializable.
   */
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
